import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_helpers/auth.guard';

const loginModule = () => import('./login/login.component').then((x) => x.LoginComponent)
const dashboardModule = () => import('./dashboard/dashboard.component').then((x) => x.DashboardComponent)
const factfeedbackModule = () => import('./fact-and-feedback/fact-and-feedback.component').then((x) => x.FactAndFeedbackComponent)
const schememdodule = () => import('./scheme-lists/scheme-lists.component').then((x) => x.SchemeListsComponent)
const schemeDetailsmodule = () => import('./user-scheme-lists/user-scheme-lists.component').then((x) => x.UserSchemeListsComponent)
const customerListsModule = () => import('./customer-list/customer-list.component').then((x)=>x.CustomerListComponent)
const branchListsModule = () => import('./branch-lists/branch-lists.component').then((x)=>x.BranchListsComponent)
const offerListsModule = () => import('./offer-details/offer-details.component').then((x)=>x.OfferDetailsComponent)
const userModule = () => import('./user-creation/user-creation.component').then((x)=>x.UserCreationComponent)
const dailyRateModule = () => import('./daily-rate/daily-rate.component').then((x)=>x.DailyRateComponent)
const BannerModule = () => import('./banners/banners.component').then((x)=>x.BannersComponent)
const GiftVoucherModule = () => import('./gift-voucher/gift-voucher.component').then((x)=>x.GiftVoucherComponent)
const ExclusiveImagesModule = () => import('./exclusive-images/exclusive-images.component').then((x)=>x.ExclusiveImagesComponent)

const routes: Routes = [
  {
    path: 'login',
    loadComponent: loginModule
  },
  {
    path: 'customer-list',
    loadComponent: customerListsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'banners',
    loadComponent: BannerModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'gift-voucher',
    loadComponent: GiftVoucherModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'explore-images',
    loadComponent: ExclusiveImagesModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'gold-plan',
    loadComponent: schememdodule,
    canActivate: [AuthGuard]
  },
  {
    path: 'daily-rate',
    loadComponent: dailyRateModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'user-gold-plan-detail',
    loadComponent: schemeDetailsmodule,
    canActivate: [AuthGuard]
  },
  {
    path: 'fact-feedback',
    loadComponent: factfeedbackModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'branch',
    loadComponent: branchListsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'user-creation',
    loadComponent: userModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'offer',
    loadComponent: offerListsModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard',
    loadComponent: dashboardModule,
    canActivate: [AuthGuard]
  },

  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
